import {ApiService} from "../Services/ApiService";

export class ClickCounter {
	constructor() {
		let api = new ApiService()
		let context = ".webinarList .c-accordion__buttons"

		jQuery('[data-webinar]', context).on('click', function () {
			let webinarUid = $(this).data('webinar');
			let property = $(this).data('property');

			api.increaseWebinarCounter(webinarUid, property);
		})
	}
}
